import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { Valence } from '@upright/common/model/types';

export enum FigureMode {
  DEFAULT,
  ONLY_COMPARISON_NOTES,
  ONLY_MONETARY_NOTES,
}

export function getFigureNotesMode(impact: ImpactCategoryId, _valence: Valence) {
  switch (impact) {
    case ImpactCategoryId.TAXES:
      return FigureMode.ONLY_MONETARY_NOTES;
    case ImpactCategoryId.SCARCE_HUMAN_CAPITAL:
      return FigureMode.ONLY_COMPARISON_NOTES;
    case ImpactCategoryId.JOBS:
      return FigureMode.ONLY_COMPARISON_NOTES;
    default:
      return FigureMode.DEFAULT;
  }
}
